import clsx from "clsx";
import { useState } from "react";
import { Action } from "../shared/action";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
} from "../shared/dropdown";
import { SharedIcon } from "../shared/shared-icon";

export function SaveColorDropdown({ actions }) {
  const [isDropdownOpen, updateIsDropdownOpen] = useState(false);

  return (
    <DropdownMenu
      open={isDropdownOpen}
      onClose={() => updateIsDropdownOpen(false)}
      onOpenChange={updateIsDropdownOpen}
    >
      <DropdownMenuTrigger className="save-color-dropdown-trigger">
        <div className="save-color-dropdown-trigger-icon-wrapper">
          <SharedIcon iconName="#sprite-ellipsis" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="save-color-dropdown-content"
        align="end"
        alignOffset={32}
        side="bottom"
        sideOffset={0}
      >
        {actions?.length &&
          actions.map(
            ({ label, className, children, clickHandler, ...props }) => (
              <Action
                className={clsx("save-color-dropdown-item", className)}
                key={label}
                onClick={(e) => {
                  if (clickHandler) {
                    clickHandler(e);
                  }
                  updateIsDropdownOpen(false);
                }}
                {...props}
              >
                {label}
                {children}
              </Action>
            )
          )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
